var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type !== "hidden"
    ? _c(
        "div",
        { staticClass: "flex-row-center-jx formBar" },
        [
          _c("span", { staticClass: "text-14-black33 formTitle" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "requireStart margin-left-4" }, [
            _vm.required
              ? _c("span", { staticClass: "color-redFE" }, [_vm._v("*")])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                disabled: _vm.showHover,
                effect: "light",
                content: _vm.hintText,
                placement: "top",
              },
            },
            [
              _vm.type === "label"
                ? _c(
                    "span",
                    {
                      staticClass: "contentRight",
                      class: _vm.disable ? "color-disable" : "color-black33",
                    },
                    [_vm._v(_vm._s(_vm.value))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "single" || _vm.type === "number"
                ? _c(
                    "el-input",
                    {
                      staticClass: "contentRight",
                      attrs: {
                        type: _vm.type === "number" ? "number" : "text",
                        placeholder: "请输入内容",
                        clearable: "",
                      },
                      on: {
                        input: function ($event) {
                          _vm.watchInput($event)
                        },
                        change: _vm.onValueChange,
                      },
                      nativeOn: {
                        mousewheel: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    },
                    [
                      _vm.needEnd
                        ? _c("template", { slot: "append" }, [_vm._v("%")])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "select"
                ? _c(
                    "el-select",
                    {
                      staticClass: "contentRight",
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.onValueChange },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    },
                    _vm._l(_vm.opinions, function (item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "datetime"
                ? _c("el-date-picker", {
                    staticClass: "contentRight",
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "timestamp",
                    },
                    on: { change: _vm.onValueChange },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "count"
                ? _c("el-input-number", {
                    staticClass: "contentRight",
                    attrs: { min: 1, label: _vm.label },
                    on: { change: _vm.onValueChange },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }